import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Breadcrumb from "../../components/Breadcrumb";

import { useTranslation } from "react-i18next";
import { Spinner, Form , Button} from "react-bootstrap";
import { connect } from "react-redux";
import { loginUser } from "../../redux/actions/authActons";


import logo from "../../assets/images/Ativo-1@4x.png";

function Login(props) {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");

  async function _handleKeyDown(e){

    if (e.key === 'Enter') {
      handleLogin(e)
    }
  }

  async function handleLogin(e) {
    e.preventDefault();
    const userData = {
      email,
      senha,
    };
    console.log(userData);
    props.loginUser(userData, props.history);
  }

  return (
    
    <div className="d-flex align-items-center auth px-0" style={{marginTop: 100}} onKeyPress={_handleKeyDown}>
      <div className="row w-100 mx-0">
        <div className="col-lg-4 mx-auto">
          <div className="auth-form-light text-left py-5 px-4 px-sm-5">
            <div className="brand-logo text-center">
              <img src={logo} style={{width:'170px'}} alt="logo" />
            </div>
            <h4 className="text-center">Login</h4>
            <Form className="pt-3">
            <Form.Group>
                  {props.errors && (
                    <Form.Control.Feedback
                      style={{ display: "block" }}
                      type="invalid"
                    >
                      {props.errors.geral}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
                <Form.Group className="search-field">
                  <Form.Control
                    type="text"
                    placeholder="E-mail"
                    onChange={(e) => setEmail(e.target.value)}
                    size="lg"
                    isInvalid={props.errors ? props.errors.email : false}
                    className="h-auto"
                  />
                  {props.errors && <Form.Control.Feedback type="invalid">
                    {props.errors.email}
                  </Form.Control.Feedback>}
                </Form.Group>
                <Form.Group className="search-field">
                  <Form.Control
                    type="password"
                    placeholder="Senha"
                    onChange={(e) => setSenha(e.target.value)}
                    size="lg"
                    isInvalid={props.senha ? props.errors.senha : false}
                    className="h-auto"
                  />
                  {props.errors && <Form.Control.Feedback type="invalid">
                    {props.errors.senha}
                  </Form.Control.Feedback>}
                </Form.Group>
              <div className="mt-3">
                <Button
                  onClick={handleLogin}
                  className="d-flex btn btn-block btn-primary btn-lg align-items-center justify-content-center font-weight-medium auth-form-btn"
                >
                 {props.loading ?  <Spinner
                      animation="border"
                      size="sm"
                      style={{ marginRight: 5 }}
                      variant="light"
                    /> : <span>LOGIN</span>}
                   
               
                  
                </Button>
              </div>
              <div className="my-2 d-flex justify-content-between align-items-center">
                {/* <div className="form-check">
                  <label className="form-check-label text-muted">
                    <input type="checkbox" className="form-check-input" />
                    <i className="input-helper"></i>
                    Mantenha-me conectado
                  </label>
                </div> */}
                <Link to="/esqueci-senha" className="text-primary"> Esqueceu a senha?</Link>
                <div className="text-center font-weight-light">
                  Não possui uma conta?{" "}
                  <Link to="/registro" className="text-primary">Registra-se</Link>
                </div> 
              </div>
              {/* <div className="mb-2">
                <button type="button" className="btn btn-block btn-facebook auth-form-btn">
                  <i className="mdi mdi-facebook mr-2"></i>Conecte-se usando o Facebook
                </button>
              </div> */}
              
            </Form>
          </div>
        </div>
      </div>
    </div>


  )
}

  


  


const mapStateToProps = (state) => ({
  loading: state.UI.loading,
  errors: state.UI.errors,
});
const mapActionsToProps = {
  loginUser,
};
export default connect(mapStateToProps, mapActionsToProps)(Login);
